module.exports = __webpack_public_path__ + "static/media/Excellence programs.9c9cdc97.png";